<script lang="ts">
    // Svelte/Jet/Models/Types
    import type { WorkHeader } from '~/jet/models';

    // Stores
    import { getI18n } from '~/stores/i18n';

    // Components
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import ProductContextMenu from '~/components/jet/ProductContextMenu.svelte';

    // Shared Components
    import SeparatedList from '@amp/web-app-components/src/components/helpers/SeparatedList.svelte';
    import WorkHeaderLockup from '@amp/web-app-components/src/components/TrackList/WorkHeaderLockup.svelte';

    // Utilities
    import { getLocale } from '~/utils/locale';
    import { formatDuration, formatISODuration } from '~/utils/datetime';

    // Shared Utilities
    import { anchorLastChar } from '@amp/web-apps-utils';

    // Imports not used for now but may be needed/need to be created later (or Music-equivalent thereof)
    //
    // import { isPlayAction } from '~/jet/models';
    // import StaticPlayButton from '~/components/jet/buttons/StaticPlayButton.svelte';
    // import ProductContextMenu from '~/components/jet/ProductContextMenu.svelte';
    // import { getJetPerform } from '~/jet';

    const i18n = getI18n();
    const locale = getLocale();
    // const perform = getJetPerform();

    /*
    TODO: rdar://90996359 (JMOTW: Tracklist: Composer Header: Needs to show both composers and artists)
    - On the Ember app we show composer name and artists. We don't have this on Jet data. Native doesn't seem to show it either. Do we need to?
    */

    /**
     * The main difference between Classical's WorkHeader and Music's ComposerHeader is the data shown within.
     * Classical shows the composer name first, then the Work name second.  Both are linkable.
     * Music shows the Work name first, with "By <ComposerName>" second.  Only the composer name(s) are linkable.
     */
    export let header: WorkHeader;
    export let showWorkDuration: boolean = true;

    $: firstRowText = header.firstRowText || '';
    $: secondRowText = header.secondRowText || '';
    $: firstRowLinks = header.firstRowLinks;
    $: secondRowLinks = header.secondRowLinks;
    $: playAction = header.playAction;
    $: isPlayable = !!playAction;
    $: durationInSeconds = Math.trunc(header.duration / 1000);
    $: formattedDuration = formatDuration(durationInSeconds, locale.language);
    $: isoDuration = formatISODuration(durationInSeconds);
    // $: playableItems = isPlayAction(playAction) && playAction.items;

    function workHeaderPlayActionHandler() {
        // TODO: Handle play action
        //       rdar://141391199 ([Classical on Web] Album/Playlist Detail Pages - Work play button)
    }
</script>

<div class="composer-header-container">
    <WorkHeaderLockup
        {isPlayable}
        firstRowText={anchorLastChar(firstRowText)}
        {secondRowText}
        {firstRowLinks}
        {secondRowLinks}
        {isoDuration}
        {formattedDuration}
        {showWorkDuration}
        clickComponent={ClickAction}
        translateFn={$i18n.t}
        on:workHeaderPlayAction={workHeaderPlayActionHandler}
    >
        <svelte:fragment slot="work-header-play-button">
            {#if playAction}
                <!-- TODO: Static Play Button -->
                <!-- rdar://141391199 ([Classical on Web] Album/Playlist Detail Pages - Work play button) -->
                <!--<StaticPlayButton
                    {playAction}
                    playButtonStyle="non-platter"
                    isStandAlone={true}
                    isFilled={false}
                />-->
            {/if}
        </svelte:fragment>

        <svelte:fragment slot="work-header-context-menu">
            <ProductContextMenu
                contextMenuAction={header.contextMenuAction}
                hasMaterial={false}
                buttonStyle="non-platter"
            />
        </svelte:fragment>
    </WorkHeaderLockup>
</div>

<style lang="scss">
    .composer-header-container {
        // We cannot use `display: contents` here, as this will break the AX tree for VO
        // and cause the entire track list to become inaccessible.
        //
        // It is valid to wrap table rows in "row groups". This keeps the AX tree valid
        // so that VO parses it correctly, while also not upsetting the existing styles.
        display: table-row-group;

        // Remove border radius from the bottom of work header
        :global(.composer-header .songs-list__col:nth-child(2)) {
            border-end-start-radius: 0;
        }

        :global(.composer-header .songs-list__col:last-child) {
            border-end-end-radius: 0;
        }
    }
</style>
